import { EntityLinks, Goal, Task, Timestamp } from '@griply/types';
import { computeGoalSubgoalProgress } from '@griply/utils';
import { useMemo } from 'react';

import { useTimeframeDifference } from './use-timeframe-difference';

export type UseGoalSubgoalProgressOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  subGoals: Goal[];
  allTasks: Task[];
  links: EntityLinks;
};

export const useGoalSubgoalProgress = (
  goal: Goal,
  {
    startDate,
    endDate,
    subGoals,
    allTasks,
    links,
  }: UseGoalSubgoalProgressOptions,
) => {
  const { entries, target } = useMemo(
    () =>
      computeGoalSubgoalProgress({ goal, subGoals, tasks: allTasks, links }),
    [goal, subGoals, allTasks, links],
  );

  const timeframeDifference = useTimeframeDifference({
    entries,
    startDate,
    endDate,
    target,
  });

  const lastEntryValue = entries[entries.length - 1]?.value;
  const completionPercentage = lastEntryValue
    ? Math.floor((lastEntryValue / subGoals.length) * 100)
    : 0;

  return {
    entries,
    completionPercentage,
    completed: subGoals.filter(({ completedAt }) => !!completedAt).length,
    target,
    timeframeDifference,
  };
};
